import Cookies from 'js-cookie'
import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  children: ReactNode
}

export const PublicRoute = ({ children }: Props) => {
  const isAuthenticated = !!Cookies.get('auth_token')
  const navigation = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigation('/home')
    }
  }, [isAuthenticated, navigation])

  if (isAuthenticated) {
    return null
  }

  return <>{children}</>
}
